var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showMainDetails
        ? _c(
            "form-accordion",
            { attrs: { title: _vm.ServiceDetails } },
            [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.rsn"),
                      inputValue: _vm.invoice.NameSeller,
                    },
                  }),
                  _vm._v(" "),
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.idtfr"),
                      inputValue: _vm.invoice.InvoiceIdentifier,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.invoice.direction === "1"
                    ? [
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputLabel: _vm.$t("common.crdtr_name"),
                            inputValue: _vm.invoice.creditorName,
                          },
                        }),
                        _vm._v(" "),
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputLabel: _vm.$t("common.crdtr_mail"),
                            inputValue: _vm.invoice.creditorIdentifier,
                          },
                        }),
                      ]
                    : _vm.invoice.direction === "0"
                    ? [
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputLabel: _vm.$t("common.debtor_name"),
                            inputValue: _vm.invoice.debtorName,
                          },
                        }),
                        _vm._v(" "),
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputLabel: _vm.$t("common.debtor_email"),
                            inputValue: _vm.invoice.debtorIdentifier,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm._l(
                    _vm.bankLabelHidden(
                      _vm.invoice.creditorBankAccount,
                      _vm.invoice.creditorZoneCode
                    ),
                    function (accountData) {
                      return [
                        _c("form-read-group-label-input", {
                          key: accountData.hiddenValue,
                          attrs: {
                            inputLabel:
                              _vm.invoice.direction === "1"
                                ? _vm.$t(accountData.labelId + "_creditor")
                                : _vm.$t(accountData.labelId + "_my"),
                            inputValue: accountData.hiddenValue,
                          },
                        }),
                      ]
                    }
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.bankLabelHidden(
                      _vm.invoice.debtorBankAccount,
                      _vm.invoice.debtorZoneCode
                    ),
                    function (debtorAccountData) {
                      return [
                        _c("form-read-group-label-input", {
                          key: debtorAccountData.hiddenValue,
                          attrs: {
                            inputLabel:
                              _vm.invoice.direction === "0"
                                ? _vm.$t(debtorAccountData.labelId + "_debtor")
                                : _vm.$t(debtorAccountData.labelId + "_my"),
                            inputValue: debtorAccountData.hiddenValue,
                          },
                        }),
                      ]
                    }
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: "Date de création du paiement",
                      inputValue: _vm._f("formatDate")(_vm.invoice.PaymentDate),
                    },
                  }),
                  _vm._v(" "),
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.status.status_label"),
                      inputValue: _vm.getStatusLabel(
                        _vm.invoice.Status,
                        _vm.invoice.direction
                      ),
                      statusIcon: _vm.getIcon(_vm.invoice.Status, "0"),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.total_amount_no_currency"),
                      inputValue:
                        _vm.invoice.Amount +
                        " " +
                        _vm.getCurrencyIcon(_vm.invoice.currency),
                    },
                  }),
                  _vm._v(" "),
                  _vm.invoice.attachmentId !== ""
                    ? _c("div", { staticClass: "form-group col-sm-6" }, [
                        _c("div", { class: _vm.colorBottomButton }, [
                          _vm.ifAndroid
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "button-action firstButtonMarginTop",
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(_vm.invoice.attachmentId)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-paperclip",
                                  }),
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(
                                        _vm.$t("creation_forms.view_attchmnt")
                                      ) +
                                      "\r\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.ifAndroid
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "milkyBlockBlack button-action firstButtonMarginTop",
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(_vm.invoice.attachmentId)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-paperclip",
                                  }),
                                  _vm._v(
                                    "\r\n              " +
                                      _vm._s(
                                        _vm.$t("creation_forms.dwnld_attchmnt")
                                      ) +
                                      "\r\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: "Date d'exécution",
                      inputValue: _vm._f("formatDate")(_vm.invoice.PaymentDate),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              [_vm.status.MADE, _vm.status.INST_MADE].includes(
                _vm.invoice.Status
              )
                ? _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "transactionDetailSubHeader",
                          attrs: { cols: "12" },
                        },
                        [
                          _vm._v(
                            "\r\n        " + _vm._s("Lettrage") + "\r\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-2", attrs: { cols: "12" } },
                        [
                          _vm._v(
                            "\r\n        " +
                              _vm._s(
                                _vm.invoice.lettrage &&
                                  _vm.invoice.lettrage.length > 0
                                  ? _vm.formatLettrage(_vm.invoice.lettrage)
                                  : "Pas de lettrage"
                              ) +
                              "\r\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMainDetails ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _c(
        "form-accordion",
        { attrs: { title: _vm.$t("common.formsSubTitle.trnsctns_hstry") } },
        [
          _vm.invoice.History && _vm.invoice.History.length > 0
            ? _c("div", [
                _c("div", { staticClass: "form-group row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-striped table-bordered table-status-history",
                      },
                      [
                        _c("thead", { staticClass: "thead-dark" }, [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "reponsiveColumnWidth",
                                attrs: { scope: "col" },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.date_label")))]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v(_vm._s(_vm.$t("common.amnt"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("common.status.status_label"))
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.invoice.History, function (record) {
                            return _c("tr", { key: record.IdTransaction }, [
                              _c(
                                "td",
                                { staticClass: "dateTimehistoryHeight" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDateTime")(
                                        record.CreationDate
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 statusHistoryLabel",
                                    },
                                    [
                                      _vm._v(
                                        "\r\n                      " +
                                          _vm._s(
                                            _vm.getDirectionIcon(
                                              record.Direction
                                            ) +
                                              " " +
                                              record.Amount +
                                              " " +
                                              _vm.getCurrencyIcon(
                                                record.Currency
                                              )
                                          ) +
                                          "\r\n                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-sm-7 statusHistoryLabel",
                                    },
                                    [
                                      _vm._v(
                                        "\r\n                      " +
                                          _vm._s(
                                            _vm.getStatusLabel(
                                              "Transaction_" + record.Status,
                                              "0"
                                            )
                                          ) +
                                          "\r\n                      "
                                      ),
                                      _c("i", {
                                        class:
                                          "icon icon-transaction-detail " +
                                          _vm.getIcon(
                                            "Transaction_" + record.Status
                                          ),
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5" },
                                    [
                                      _vm.showPain001View(record)
                                        ? _c(
                                            "f7-button",
                                            {
                                              staticClass:
                                                "xmlButtonBackground",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewXML()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.button_technical_details"
                                                    )
                                                  ) +
                                                  "\r\n                      "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ])
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    background: "#dcdcdc",
                  },
                },
                [
                  _vm._v(
                    "\r\n      " +
                      _vm._s(_vm.$t("common.no_transaction_yet")) +
                      "\r\n    "
                  ),
                ]
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }